import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button } from '@betareader/design-system';
import AppIcon from '../../../components/AppIcon';

import moment from 'moment';

// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withTranslation } from 'react-i18next';

import CancelSubscriptionModal from './cancelSubscriptionModal';

import { getNextSubscriptionPayment } from '../../../modules/subscription';
import { getUserProfile } from '../../../modules/user';

import currencyUtil from '../../../utils/currencyUtil';
import { withHostAppProxy } from '../../../contexts/HostAppProxyContext';
import { toast } from 'react-toastify';
import './subscription.css';

const canManagePaddleSubscription = subscription =>
  subscription?.provider === 'PADDLE' &&
  subscription.environment === (
    process.env.REACT_APP_FIREBASE_ENV === 'production' ? 'PRODUCTION' : 'SANDBOX'
  ) &&
  subscription.pricingPlan?.product?.internalId !== 'free';

export class Subscription extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.nativeRefreshTimers = [];
  }

  componentDidMount() {
    const { userProfile, hostAppProxy } = this.props;
    const subscription = userProfile.account.subscription;
    if (!hostAppProxy.settings.isWrapped && canManagePaddleSubscription(subscription) && subscription?.status !== 'deleted' && subscription?.pricingPlan?.externalId) {
      this.getNextPayment(userProfile.account.subscription._id);
    }
  }

  componentDidUpdate(prevProps) {
    const previousEvent = prevProps.hostAppProxy?.settings?.nativePurchaseEvent;
    const event = this.props.hostAppProxy?.settings?.nativePurchaseEvent;
    if (!event || event === previousEvent) return;
    if (event.data?.status === 'success') {
      toast.success(
        event.data?.operation === 'restore'
          ? this.props.t('PurchasesRestored', 'Purchases restored.')
          : this.props.t('PurchaseSuccessful', 'Purchase successful.')
      );
      [500, 2000, 5000].forEach(delay => {
        this.nativeRefreshTimers.push(
          setTimeout(
            () => this.props.getUserProfile(this.props.idToken),
            delay
          )
        );
      });
    } else if (event.data?.status === 'cancelled') {
      toast.info(this.props.t('Cancelled'));
    } else if (event.data?.status === 'error') {
      toast.error(
        this.props.t(
          'PurchaseFailed',
          'The purchase could not be completed.'
        )
      );
    }
  }

  componentWillUnmount() {
    this.nativeRefreshTimers.forEach(timer => clearTimeout(timer));
  }

  getNextPayment = async (subscriptionId) => {
    const { idToken } = this.props;
    this.props.getNextSubscriptionPayment(idToken, subscriptionId);
  }

  changePaymentInfo = () => {
    const { userProfile } = this.props;
    if (userProfile && userProfile.account.subscription && userProfile.account.subscription.updateUrl) {
      this.setState({
        loadingPaddleCheckout: true
      }, () => {
        window.Paddle.Checkout.open({
          override: userProfile.account.subscription.updateUrl,
          loadCallback: this.loadedPaddleCheckout
        });
      });
    }
  }

  loadedPaddleCheckout = () => {
    this.setState({
      loadingPaddleCheckout: false
    });
  }

  upgradeSubscription = () => {
    const { changePage } = this.props;
    changePage('/products');
  }

  showCancelModal = (show) => {
    this.setState({
      showCancelModal: show
    });
  }

  render() {
    const { loadingPaddleCheckout } = this.state;
    const { userProfile, nextPayment, t } = this.props;
    if (!userProfile || !userProfile.account.subscription) {
      return (
        <div className="subscription-placeholder" role="status" aria-label={t('Loading')}>
          <span /><span /><span /><span />
        </div>
      );
    }
    const { subscription } = userProfile.account;
    const { showCancelModal } = this.state;
    const hostSettings = this.props.hostAppProxy?.settings || {};
    const isNative = Boolean(hostSettings.isWrapped);
    const isPaid =
      subscription.pricingPlan?.product?.internalId !== 'free';
    const isAppleManaged = subscription.provider === 'APPLE';
    const canManagePaddle = !isNative && canManagePaddleSubscription(subscription);

    return (
      <div>
        {!isNative && <CancelSubscriptionModal open={showCancelModal} onClose={() => this.showCancelModal(false)} />}
        {
          subscription.status !== 'deleted' && (
            <div>
              <div className="subscription-section-heading">
                <div>
                  <h4>{subscription.pricingPlan && t(subscription.pricingPlan.product.title)}</h4>
                  {canManagePaddle && nextPayment && (
                    <p>
                      {`${t('NextPayment')}: ${nextPayment.amount}${currencyUtil.getSymbol(nextPayment.currency)} (${moment(nextPayment.payout_date).format('L')})`}
                      {subscription.status === 'past_due' && (
                        <span className="subscription-payment-error">
                          {t('PaymentPastDueMessage', {nextAttempt: new Date(subscription.nextRetryDate).toLocaleDateString()})}
                        </span>
                      )}
                    </p>
                  )}
                </div>
                {canManagePaddle && (
                  <Button variant="danger" size="small" onClick={() => this.showCancelModal(true)}>{t('Cancel')}</Button>
                )}
              </div>
              <hr className="subscription-action-divider" />
              { canManagePaddle
              && (
                <>
                  <div className="subscription-section-heading">
                    <div>
                      <h4>{t('ChangePaymentInformation')}</h4>
                      <p className="subscription-payment-icons"><AppIcon name="payment" aria-hidden="true" /> <span>PayPal</span></p>
                    </div>
                    <Button variant="secondary" size="small" onClick={this.changePaymentInfo}>{t('Update')}</Button>
                  </div>
                  <hr className="subscription-action-divider" />
                </>
              )
            }
            </div>
          )
        }
        {isNative && hostSettings.purchaseMode === 'ios_iap' && (
          <React.Fragment>
            <div className='subscription-action-row subscription-action-row--native'>
              <div className='subscription-action-copy'>
                <div className="subscription-section-title">
                  <h4>
                  {t('AppStorePurchases', 'App Store purchases')}
                  </h4>
                  {subscription.provider === 'PADDLE' && isPaid && (
                    <p>
                      {t(
                        'ManageWebSubscription',
                        'Your existing web subscription remains active. Manage it on betareader.io.'
                      )}
                    </p>
                  )}
                </div>
              </div>
              <div className='subscription-actions'>
                <Button
                  variant="secondary"
                  onClick={this.props.hostAppProxy.restorePurchases}
                >{t('RestorePurchases', 'Restore purchases')}</Button>
                <Button
                  variant="secondary"
                  onClick={this.props.hostAppProxy.manageSubscriptions}
                >{t('ManageSubscription', 'Manage subscription')}</Button>
              </div>
            </div>
            <hr className='subscription-action-divider' />
          </React.Fragment>
        )}
        {!isNative && isAppleManaged && isPaid && (
          <React.Fragment>
            <div className='subscription-action-row subscription-action-row--apple-web'>
              <div className='subscription-action-copy'>
                <h4>{t('AppStorePurchases', 'App Store purchases')}</h4>
              </div>
              <div className='subscription-actions'>
                <a
                  className="br-button br-button--secondary br-button--medium"
                  href='https://apps.apple.com/account/subscriptions'
                  target='_blank'
                  rel='noopener noreferrer'
                >{t('ManageSubscription', 'Manage subscription')}</a>
              </div>
            </div>
            <hr className='subscription-action-divider' />
          </React.Fragment>
        )}
        {
          subscription.status === 'deleted'
          && (
            <div className="subscription-section-title">
              <h4>{subscription.pricingPlan && t(subscription.pricingPlan.product.title)}</h4>
              <p>
                {t('YourSubscriptionHasBeenCancelled')}
                <br />
                {t('ValidUntil')}
                {' '}
                {moment(subscription.validUntilDate).format('L')}
              </p>
            </div>
          )
        }
        <div className='subscription-action-row subscription-action-row--upgrade'>
          <div className='subscription-action-copy'>
            <div className="subscription-section-title">
              <h4>{t('UpgradeSubscriptionTitle')}</h4>
              <p>{t('UpgradeSubscriptionPromoText')}</p>
            </div>
          </div>
          <div className='subscription-actions'>
            <Button variant="secondary" onClick={this.upgradeSubscription}>{t('Subscriptions')}</Button>
          </div>
        </div>
        {
          loadingPaddleCheckout && (
            <div className="subscription-loading-overlay" role="status" aria-live="polite">{t('Loading')}</div>
          )
        }
      </div>
    );
  }
}

// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  nextPayment: state.subscription.nextPayment
});

const mapDispatchToProps = dispatch => bindActionCreators({
  getNextSubscriptionPayment,
  getUserProfile,
  changePage: newPage => push(newPage)
}, dispatch);

export default withTranslation()(
  withHostAppProxy(
    withRouter(connect(mapStateToProps, mapDispatchToProps)(Subscription))
  )
);
